import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../authConfig.js";

export default function LoginPage() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [signingIn, setSigningIn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/config", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    setSigningIn(true);
    setError(null);
    // Use redirect flow — the page navigates to Microsoft login,
    // then redirects back to /config after authentication.
    instance.loginRedirect(loginRequest).catch((err) => {
      console.error("[LoginPage] Login redirect failed:", err);
      setError(err.message || "Sign-in failed. Please try again.");
      setSigningIn(false);
    });
  };

  return (
    <>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
        button { transition: filter .12s; }
        button:not(:disabled):hover { filter: brightness(.96); }
        button:not(:disabled):active { transform: scale(.99); }
      `}</style>

      <div style={{ minHeight: "100vh", background: "#F5FAFA", fontFamily: "-apple-system,'Segoe UI',system-ui,sans-serif", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px" }}>
        <div style={{ background: "#fff", border: "1.5px solid #E2E8F0", borderRadius: 16, padding: "48px 48px 40px", textAlign: "center", maxWidth: 420, width: "100%", animation: "fadeUp .4s ease both" }}>

          {/* Logo */}
          <div style={{ marginBottom: 32 }}>
            <img src="/logo.png" alt="Mekorma" style={{ height: 32, margin: "0 auto 16px", display: "block" }} />
            <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0F172A", margin: "0 0 6px" }}>
              Booking Configuration
            </h1>
            <p style={{ fontSize: 14, color: "#64748B", margin: 0, lineHeight: 1.6 }}>
              Sign in with your Microsoft work account to access the configuration panel.
            </p>
          </div>

          {/* Sign in button */}
          <button
            onClick={handleLogin}
            disabled={signingIn}
            style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 10,
              width: "100%", padding: "13px 24px", borderRadius: 10, border: "1.5px solid #E2E8F0",
              background: "#fff", color: "#0F172A", fontWeight: 600, fontSize: 14,
              cursor: signingIn ? "not-allowed" : "pointer", opacity: signingIn ? 0.7 : 1,
            }}
          >
            {signingIn ? (
              <>
                <div style={{ width: 16, height: 16, border: "2px solid #E2E8F0", borderTopColor: "#004e42", borderRadius: "50%", animation: "spin .75s linear infinite" }} />
                Redirecting...
              </>
            ) : (
              <>
                {/* Microsoft logo */}
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <rect x="1" y="1" width="6.5" height="6.5" fill="#F25022"/>
                  <rect x="8.5" y="1" width="6.5" height="6.5" fill="#7FBA00"/>
                  <rect x="1" y="8.5" width="6.5" height="6.5" fill="#00A4EF"/>
                  <rect x="8.5" y="8.5" width="6.5" height="6.5" fill="#FFB900"/>
                </svg>
                Sign in with Microsoft
              </>
            )}
          </button>

          {error && (
            <div style={{ marginTop: 16, padding: "10px 14px", borderRadius: 8, background: "#FEF2F2", border: "1px solid #FECACA" }}>
              <p style={{ fontSize: 13, color: "#DC2626", margin: 0 }}>{error}</p>
            </div>
          )}

          <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid #F1F5F9" }}>
            <button
              onClick={() => navigate("/")}
              style={{ background: "none", border: "none", color: "#64748B", fontSize: 13, cursor: "pointer", textDecoration: "underline" }}
            >
              Back to Booking
            </button>
            <p style={{ fontSize: 11, color: "#CBD5E1", margin: "12px 0 0" }}><span style={{ color: "#88c96c", fontWeight: 700 }}>Mekorma</span> · Booking Platform · Powered by Microsoft Graph, Bookings and Dynamics CRM</p>
          </div>
        </div>
      </div>
    </>
  );
}
